import { AppsPermissions } from '../DashboardModule/modulepermissions';
import {
  cashDrawerPosModule,
  clockPosModule,
  dashboardPosModule,
  headerPosModule,
  menuPosModule,
  orderHubPosModule,
  paymentPosModule,
  tableLayoutPosModule,
  ticketPosModule,
} from '../PosModules/moduleFeatures';

export const defaultBarBackPermissions = [
  {
    id: 977,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: null,
    featureId: null,
    key: 'mom-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 978,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 1,
    featureId: null,
    key: 'my-restaurant-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 979,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 2,
    featureId: null,
    key: 'my-account-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 980,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 3,
    featureId: null,
    key: 'timecards-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 981,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 4,
    featureId: null,
    key: 'employee-availability-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 982,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: null,
    key: 'employee-time-off-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 983,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: null,
    key: 'employee-management-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 984,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: null,
    key: 'shift-scheduler-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 985,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: null,
    key: 'shift-pool-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 986,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: null,
    key: 'task-manager-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 987,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 37,
    featureId: null,
    key: 'docvault-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 988,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: null,
    key: 'dashboard-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 989,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: null,
    key: 'lost-&-found-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 990,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 42,
    featureId: null,
    key: 'pay-management-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 991,
    roleId: 14,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 1,
    featureId: 5,
    key: 'recurring-payment-method-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 992,
    roleId: 14,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 1,
    featureId: 5,
    key: 'recurring-payment-method-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 993,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 994,
    roleId: 14,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 995,
    roleId: 14,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 996,
    roleId: 14,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 997,
    roleId: 14,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 998,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 3,
    featureId: 12,
    key: 'view-own-timecards-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 999,
    roleId: 14,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 3,
    featureId: 12,
    key: 'view-own-timecards-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1000,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1001,
    roleId: 14,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1002,
    roleId: 14,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1003,
    roleId: 14,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1004,
    roleId: 14,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1005,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1006,
    roleId: 14,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1007,
    roleId: 14,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1008,
    roleId: 14,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1009,
    roleId: 14,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1010,
    roleId: 14,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1011,
    roleId: 14,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1012,
    roleId: 14,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1013,
    roleId: 14,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1014,
    roleId: 14,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1015,
    roleId: 14,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1016,
    roleId: 14,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1017,
    roleId: 14,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1018,
    roleId: 14,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 23,
    key: 'documents-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1019,
    roleId: 14,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 23,
    key: 'documents-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1020,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 31,
    key: 'own-shifts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1021,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 33,
    key: 'release-other-employees-shift-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1022,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 34,
    key: 'release-shifts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1023,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 35,
    key: 'assign-to-another-employee-button-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1024,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 118,
    key: 'release-manager-approval-required-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1025,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 119,
    key: 'bid-on-open-shifts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1026,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: 36,
    key: 'pool-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1027,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: 37,
    key: 'pool-view-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1028,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: 86,
    key: 'can-be-assigned-a-task-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1029,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1030,
    roleId: 14,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1031,
    roleId: 14,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1032,
    roleId: 14,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1033,
    roleId: 14,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1034,
    roleId: 14,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1035,
    roleId: 14,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1036,
    roleId: 14,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1037,
    roleId: 14,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1038,
    roleId: 14,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1039,
    roleId: 14,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1040,
    roleId: 14,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1041,
    roleId: 14,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1042,
    roleId: 14,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1043,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: 11,
    key: 'your-week-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1044,
    roleId: 14,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 38,
    featureId: 11,
    key: 'your-week-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1045,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1046,
    roleId: 14,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1047,
    roleId: 14,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1048,
    roleId: 14,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1049,
    roleId: 14,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1050,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1051,
    roleId: 14,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1052,
    roleId: 14,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1053,
    roleId: 14,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1054,
    roleId: 14,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1055,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 127,
    key: 'mark-as-retrieved-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1056,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 42,
    featureId: 132,
    key: 'view-own-paystubs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1513,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: null,
    featureId: null,
    key: 'pos-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1514,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: null,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1515,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 133,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1651,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: null,
    featureId: null,
    key: 'mpos-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1652,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 22,
    featureId: null,
    key: 'login-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1653,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 22,
    featureId: 77,
    key: 'login-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3473,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 70,
    key: 'employee-attendance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3486,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 47,
    key: 'table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3487,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 58,
    key: 'change-table-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3488,
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 18,
    featureId: 58,
    key: 'change-table-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
];

export const barBackDefaultPosPermission = [
  AppsPermissions['web-dash-visible'],

  clockPosModule['clock-in-visible-module'],
  clockPosModule['clock-in-visible'],
  clockPosModule['device-status-visible'],

  tableLayoutPosModule['table-layout-visible'],
  tableLayoutPosModule['table-visible'],
  tableLayoutPosModule['table-status-visible'],
  tableLayoutPosModule['switch-floors-visible'],
  tableLayoutPosModule['view-seating-capacity-visible'],
  tableLayoutPosModule['assign-server-visible'],

  menuPosModule['menu-visible'],
  menuPosModule['item-level-comp-visible-is-approval-needed'],

  paymentPosModule['payments-visible'],
  paymentPosModule['adjust-visible-is-approval-needed'],
  paymentPosModule['refund-visible-is-approval-needed'],
  paymentPosModule['tenders-visible-is-approval-needed'],
  paymentPosModule['update-visible-is-approval-needed'],

  ticketPosModule['ticket-visible'],
  ticketPosModule['service-charges-visible-is-approval-needed'],
  ticketPosModule['custom-item-visible-is-approval-needed'],
  ticketPosModule['tax-exempt-visible-is-approval-needed'],
  ticketPosModule['change-table-visible-is-approval-needed'],
  ticketPosModule['change-server-visible-is-approval-needed'],
  ticketPosModule['void-order-visible-is-approval-needed'],
  ticketPosModule['ticket-level-comp-visible-is-approval-needed'],

  headerPosModule['header-visible'],
  headerPosModule['settings-hamburger-visible'],
  headerPosModule['orders-hub-hamburger-visible'],
  headerPosModule['restaurant-type-hamburger-visible'],
  headerPosModule['cashdrawer-visible'],
  headerPosModule['aio-help-center-visible'],

  dashboardPosModule['dashboard-visible'],
  dashboardPosModule['my-day-visible'],
  dashboardPosModule['overview-visible'],
  dashboardPosModule['z-report-visible'],
  dashboardPosModule['employee-attendance-visible'],

  cashDrawerPosModule['cashdrawer-visible'],
  cashDrawerPosModule['other-stations-visible'],
  cashDrawerPosModule['house-drawer-visible'],
  cashDrawerPosModule['logs-visible'],
  cashDrawerPosModule['adjust-starting-balance-visible-is-approval-needed'],
  cashDrawerPosModule['close-drawer-visible-is-approval-needed'],

  orderHubPosModule['order-hub-visible'],
  orderHubPosModule['ticket-visible-is-approval-needed'],
];
